<template>
  <div v-if="message" class="alert alert-success text-center" role="alert">
    {{message}}
  </div>
</template>

<script>
export default {
  name: "AlertSuccess",
  props:{
    message:String
  }
}
</script>

<style scoped>

</style>